"use client";

import { useState } from "react";
import Link from "next/link";
import { I, Slash } from "@/components/kamibot-v2/discord";
import { Container, SectionHead } from "@/components/kamibot-v2/common";

const INVITE_URL = "https://discord.gg/kamibot";

export function Steps() {
  const [copied, setCopied] = useState(false);

  function copyInvite() {
    try {
      navigator.clipboard?.writeText(INVITE_URL);
    } catch {
      /* ignore */
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1600);
  }

  return (
    <section id="start">
      <Container>
        <SectionHead
          eyebrow="GET STARTED"
          title="3단계면 끝나요. 정말이에요."
          sub="로그인도, 회원가입도, 카드 등록도 필요 없어요. 디스코드 권한만 한 번."
        />
        <div className="steps">
          <div className="step">
            <span className="num">
              <b>01</b> · INVITE
            </span>
            <h4>서버에 초대</h4>
            <p>버튼 한 번이면 디스코드 권한 화면으로 넘어가요. 필요한 권한만 받아갈게요.</p>
            <div className="step-actions">
              <a
                className="btn btn-primary btn-sm"
                href={INVITE_URL}
                target="_blank"
                rel="noopener"
              >
                <I.discord /> 초대하기
              </a>
              <button
                type="button"
                className={`btn btn-ghost btn-sm ${copied ? "is-copied" : ""}`}
                onClick={copyInvite}
              >
                {copied ? (
                  <>
                    <I.check /> 복사됨
                  </>
                ) : (
                  <>
                    <I.copy /> 초대 링크 복사
                  </>
                )}
              </button>
            </div>
          </div>
          <div className="step">
            <span className="num">
              <b>02</b> · TRY
            </span>
            <h4>설정 없이 바로 사용하기</h4>
            <p>채팅창에 슬래시(/)를 누르면 카미봇이 할 수 있는 게 전부 보여요. 골라서 누르면 끝.</p>
            <div className="hint">
              <Slash name="tts" /> 안녕하세요
            </div>
          </div>
          <div className="step">
            <span className="num">
              <b>03</b> · TWEAK
            </span>
            <h4>대시보드에서 무엇이든 커스터마이징</h4>
            <p>환영 메시지, 자동 번역, 임시 음성 채널 같은 건 대시보드에서 시각적으로 켜고 끄세요.</p>
            <div className="step-actions">
              <Link className="btn btn-primary btn-sm" href="/dashboard">
                대시보드 열기 <I.arrow />
              </Link>
              <span className="step-actions-note mono">kamibot.app/dashboard</span>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
